import styled from "styled-components";
const Title = styled.p`
  font-size: 3rem;
  text-align: center;
  padding: 2rem 0 1rem;
`;
export const MainTitle = styled(Title)`
  font-weight: bold;
`;
export const SectionTitle = styled(Title)`
  font-weight: normal;
`;
